<template>
  <div v-if="cart">
    <div class="container">
      <div class="card mb-5">
        <div class="card-header">
          <strong>Warenkorb</strong>
        </div>
        <div class="card-body" v-if="cart.items.length == 0 && status == 'idle'">
          <div class="lead text-center">
            Ihr Warenkorb ist leer.
          </div>
        </div>
        <ul class="list-group list-group-flush">
          <li v-for="(item, index) of cart.items" :key="index" class="list-group-item">
            <div class="row mb-4">
              <div class="col-md">
                <div>
                  <strong>{{ item.name }}</strong>
                </div>
                <div v-for="(value, i) of item.meta" :key="i">
                  {{ value }}
                </div>
              </div>
              <div class="col-md-auto">
                <span v-if="item.type == 'coupon'">
                  -{{ item.price | currency }}
                </span>
                <span v-else>
                  {{ item.price | currency }}
                </span>
              </div>
            </div>

            <div v-for="child of item.children" :key="child.key" class="row mb-4">
              <div class="col-md">
                <div>
                  <strong>{{ child.name }}</strong>
                </div>
                <div v-for="(value, i) of child.meta" :key="i">
                  {{ value }}
                </div>
              </div>
              <div class="col-md-auto">
                <span v-if="child.type == 'coupon'">
                  - {{ child.price | currency }}
                </span>
                <span v-else>
                  {{ child.price | currency }}
                </span>
              </div>
            </div>
            <div>
              <a href="#" class="text-danger" @click.prevent="deleteItem(item)">Löschen</a>
            </div>
          </li>
        </ul>
        <div v-if="shipping" class="card-footer">
          <div class="row">
            <div class="col-md">
              <span>Versand</span>
            </div>
            <div class="col-md-auto">
              {{ shipping.total.shipping | currency }}
            </div>
          </div>
          <div class="row">
            <div class="col-md">
              <strong>Gesamt</strong>
            </div>
            <div class="col-md-auto">
              <strong>{{ shipping.total.total | currency }}</strong>
            </div>
          </div>
        </div>
      </div>


      <div v-if="(status == 'idle' || status == 'processing') && cart.items.length > 0">
        <div v-if="shipping.total.total > 0" class="card mb-5">
          <div class="card-header">
            <strong>Versand</strong>
          </div>
          <div class="card-body">
            <div v-if="cart.shipping" class="row">
              <div v-for="option of cart.shipping" :key="option.id" class="col-md">
                <div class="card text-center" :class="{'active': shipping == option}"
                  @click.prevent="shipping = option">
                  <div class="card-body">
                    {{ option.name }} <span>{{ option.price | currency }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="shipping.total.total > 0" class="card mb-5">
          <div class="card-header">
            <strong>Ihre Daten</strong>
          </div>
          <div class="card-body">
            <div class="form-group">
              <strong>Rechnungsadresse</strong>
            </div>
            <div class="row">
              <div class="col-md">
                <div class="form-group">
                  <label for="">Firma</label>
                  <input type="text" class="form-control" v-model="customer.billing.company" placeholder="Firma">
                </div>
              </div>
              <div class="col-md">
                <div class="form-group">
                  <label for="">Vorname</label>
                  <input type="text" class="form-control" v-model="customer.billing.first_name" placeholder="Vorname">
                </div>
              </div>
              <div class="col-md">
                <div class="form-group">
                  <label for="">Nachname</label>
                  <input type="text" class="form-control" v-model="customer.billing.last_name" placeholder="Nachname">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md">
                <div class="form-group">
                  <label for="">Straße / Nr.</label>
                  <input type="text" class="form-control" v-model="customer.billing.address_line_1" placeholder="Straße / Nr.">
                </div>
              </div>
              <div class="col-md">
                <div class="form-group">
                  <label for="">PLZ</label>
                  <input type="text" class="form-control" v-model="customer.billing.zip" placeholder="PLZ">
                </div>
              </div>
              <div class="col-md">
                <div class="form-group">
                  <label for="">Ort</label>
                  <input type="text" class="form-control" v-model="customer.billing.city" placeholder="Ort">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md">
                <div class="form-group">
                  <label for="">E-Mail-Adresse</label>
                  <input type="text" class="form-control" v-model="customer.billing.email" placeholder="E-Mail-Adresse">
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="form-check">
                <input type="checkbox" id="use_shipping" class="form-check-input" v-model="customer.use_shipping">
                <label for="use_shipping" class="form-check-label">Ich möchte eine abweichende Lieferadresse angeben</label>
              </div>
            </div>
            <div v-if="customer.use_shipping">
              <div class="form-group">
                <strong>Lieferadresse</strong>
              </div>
              <div class="row">
                <div class="col-md">
                  <div class="form-group">
                    <label for="">Firma</label>
                    <input type="text" class="form-control" v-model="customer.shipping.company" placeholder="Firma">
                  </div>
                </div>
                <div class="col-md">
                  <div class="form-group">
                    <label for="">Vorname</label>
                    <input type="text" class="form-control" v-model="customer.shipping.first_name" placeholder="Vorname">
                  </div>
                </div>
                <div class="col-md">
                  <div class="form-group">
                    <label for="">Nachname</label>
                    <input type="text" class="form-control" v-model="customer.shipping.last_name" placeholder="Nachname">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md">
                  <div class="form-group">
                    <label for="">Straße / Nr.</label>
                    <input type="text" class="form-control" v-model="customer.shipping.address_line_1" placeholder="Straße / Nr.">
                  </div>
                </div>
                <div class="col-md">
                  <div class="form-group">
                    <label for="">PLZ</label>
                    <input type="text" class="form-control" v-model="customer.shipping.zip" placeholder="PLZ">
                  </div>
                </div>
                <div class="col-md">
                  <div class="form-group">
                    <label for="">Ort</label>
                    <input type="text" class="form-control" v-model="customer.shipping.city" placeholder="Ort">
                  </div>
                </div>
              </div>
            </div><!-- v-if customer.use_shipping -->
          </div>
        </div>


        <div v-if="shipping.total.total > 0" class="card mb-5">
          <div class="card-header">
            <strong>Bezahlung</strong>
          </div>
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-md-4" v-for="option of payment_options" :key="option.type">
                <div class="card text-center" :class="{'active': payment == option}"
                  @click.prevent="payment = option">
                  <div class="card-body">
                    {{ option.label }}
                  </div>
                </div>
              </div>
            </div>

            <div v-if="payment.type == 'vrpay'">
              <p class="lead">
                Bitte geben Sie <strong>Kontoinhaber</strong> und <strong>IBAN</strong> an.
              </p>

              <div class="form-group">
                <label for="">Kontoinhaber</label>
                <input type="text" class="form-control" v-model="payment.fields.holder" placeholder="Kontoinhaber">
              </div>
              <div class="form-group">
                <label for="">IBAN</label>
                <input type="text" class="form-control" v-model="payment.fields.iban" placeholder="IBAN">
              </div>
            </div>

            <div v-if="payment.type != 'vrpay'">
              <p v-if="payment.type == 'local'" class="lead">
                Bitte lassen Sie Ihren Einkauf von einem Mitarbeiter bestätigen. Sie zahlen den Betrag von {{ shipping.total.total | currency }} anschließend an der Kasse.
              </p>

              <div class="form-group">
                <label for="">Kennwort (auszufüllen von Spaß mit Sport)</label>
                <input type="password" class="form-control" v-model="payment.fields.password" placeholder="Kennwort">
              </div>
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="form-check">
            <input type="checkbox" id="checkout-privacy" class="form-check-input" v-model="customer.privacy">
            <label for="checkout-privacy" class="form-check-label">Ich habe die Datenschutzbestimmungen gelesen und akzeptiere
              sie</label>
          </div>
        </div>

        <div v-if="errors.length > 0" class="alert alert-danger mb-3">
          <div v-for="error of errors" :key="error">{{ error }}</div>
        </div>

        <button class="btn btn-block btn-primary" @click="submit()" :disabled="status == 'processing'">
          <span v-if="status == 'processing'">...</span>
          <span v-else>
            <span v-if="isOrderFreeOfCharge">Kostenlos anmelden</span>
            <span v-else>Kostenpflichtig bestellen</span>
          </span>
        </button>
      </div><!-- v-if status == idle -->
      <div v-else-if="status == 'fatal'">
        <div class="alert alert-danger text-center lead">
          <div class="row justify-content-center">
            <div class="col-md-8">
              Es ist ein Serverfehler aufgetreten. Bitte senden Sie eine E-Mail an <a href="mailto:support@spass-mit-sport.de">support@spass-mit-sport.de</a>.
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="status == 'complete'">
        <div class="alert alert-success text-center lead">
          <div class="row justify-content-center">
            <div class="col-md-8">
              Ihre Bestellung wurde erfolgreich abgeschickt. Sie erhalten dazu in wenigen Minuten eine Bestellbestätigung an Ihre E-Mail-Adresse: <br>
              <strong>{{ customer.billing.email }}</strong>
            </div>
          </div>
        </div>
      </div><!-- v-else -->
    </div>
  </div>
</template>

<script>
  import axios from 'axios'

  axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';


  export default {
    name: 'Cart',
    data: function () {
      return {
        cartKey: null,
        errors: [],
        cart: null,
        customer: {
          billing: {
            first_name: '',
            last_name: '',
            address_line_1: '',
            zip: '',
            city: '',
            email: '',
          },
          shipping: {
            first_name: '',
            last_name: '',
            address_line_1: '',
            zip: '',
            city: '',
            email: '',
          },
          use_shipping: false,
          privacy: false,
        },
        payment: null,
        status: 'processing',
        shipping: null,

        show_local_payment: false,
      }
    },
    computed: {
      isOrderFreeOfCharge() {
        return this.shipping && this.shipping.total.total === 0
      },
      payment_options() {
        return this.cart.payment.filter(option => {

          let show_local_payment = false

          if (document.body.classList.contains('show-local-payment')) {
            show_local_payment = true
          } else if (localStorage.getItem('show_local_payment') == 1) {
            show_local_payment = true
          }
          
          if (option.type !== 'vrpay')
            return show_local_payment
          
          return true
        })
      }
    },
    mounted() {
      this.cartKey = localStorage.getItem('lex_cart_key')
      this.reloadData()
      this.setBillingAddressDefaults()
    },
    methods: {
      setBillingAddressDefaults() {
        const billing = this.$defaults.billingAddress
        if (billing) {
          this.customer.billing.company = billing.company || ''
          this.customer.billing.first_name = billing.first_name || ''
          this.customer.billing.last_name = billing.last_name || ''
          this.customer.billing.address_line_1 = billing.address_line_1 || ''
          this.customer.billing.zip = billing.zip || ''
          this.customer.billing.city = billing.city || ''
          this.customer.billing.email = billing.email || ''
        }
      },
      reloadData() {
        axios.get(process.env.VUE_APP_API_URL + '/cart/' + this.cartKey, {
          withCredentials: true,
        }).then(response => {
          this.cart = response.data
          this.payment = this.cart.payment[0]
          this.shipping = this.cart.shipping[0]
          this.customer.billing = this.cart.customer.billing
          this.status = 'idle'
        })
      },
      deleteItem(item) {
        if (confirm('Möchten Sie ' + item.name + ' wirklich aus dem Warenkorb entfernen?')) {
          axios.delete(process.env.VUE_APP_API_URL + '/cart/' + this.cartKey + '/items/' + item.key, {
            withCredentials: true,
          }).then(() => {
            this.status = 'idle'
            this.reloadData()
          })
        }
      },
      submit() {
        this.errors = []
        this.status = 'processing'
        const body = {
          payment: this.payment,
          shipping: this.shipping,
          customer: this.customer,
          cart_key: this.cartKey,
        }

        axios.post(process.env.VUE_APP_API_URL + '/orders', body, {
          withCredentials: true,
        }).then(response => {
          if (response.data.status == 'success') {
            this.status = 'complete'
          }
        }).catch(error => {
          this.status = 'fatal';
          const data = error.response.data
          for (let key in data.errors) {
            const error = data.errors[key]
            this.errors = this.errors.concat(error)
            this.status = 'idle'
          }
        })
      }
    }
  }
</script>